<template>
  <div class="mt-5 mb-4">
    <h2 class="text-h5 font-weight-bold mb-4">Frequently Asked Questions</h2>
    <v-expansion-panels v-model="openPanel" variant="accordion" class="mb-4 faq-panels">
      <v-expansion-panel class="mb-2">
        <v-expansion-panel-title class="px-3 py-3">
          <span class="font-weight-medium">Who operates this service?</span>
        </v-expansion-panel-title>
        <v-expansion-panel-text class="px-3 py-3">
          <p><strong>{{ serviceProviderName }}</strong> operates this service.</p>
          <trip-advisor-reviews v-if="serviceProviderName === 'Diskubre Palawan'" />
        </v-expansion-panel-text>
      </v-expansion-panel>
      
      <v-expansion-panel class="mb-2">
        <v-expansion-panel-title class="px-3 py-3">
          <span class="font-weight-medium">How long is this service?</span>
        </v-expansion-panel-title>
        <v-expansion-panel-text class="px-3 py-3">
          <p>This service has an estimated duration of <strong>{{
            duration.replace('h', ' hours ').replace('m', ' minutes')
          }}</strong> to complete.</p>
        </v-expansion-panel-text>
      </v-expansion-panel>
      
      <v-expansion-panel v-if="listingType === 'SHARED_TRANSFER'" class="mb-2">
        <v-expansion-panel-title class="px-3 py-3">
          <span class="font-weight-medium">How much is this service?</span>
        </v-expansion-panel-title>
        <v-expansion-panel-text class="px-3 py-3">
          <p>
            <span><strong><span class="rate">{{ formatCurrency(baseRate, currency, locale) }}</span>
            </strong> per seat.</span>
          </p>
        </v-expansion-panel-text>
      </v-expansion-panel>
      
      <v-expansion-panel class="mb-2">
        <v-expansion-panel-title class="px-3 py-3">
          <span class="font-weight-medium">What are departure times?</span>
        </v-expansion-panel-title>
        <v-expansion-panel-text class="px-3 py-3">
          <p v-if="schedules.length === 0">
            This is a <strong>exclusive/private service</strong>, you can
            depart on preferred time of your choosing. Only your group can participate.
          </p>
          <p v-else>
            Departure times are <strong>{{ schedules.join(', ') }}</strong> daily.
          </p>
        </v-expansion-panel-text>
      </v-expansion-panel>
    </v-expansion-panels>
  </div>
</template>

<script setup>
import { formatCurrency } from '~/utils/index';
import { ref, onMounted } from 'vue';

// Set first panel open by default
const openPanel = ref(0);

const props = defineProps({
  serviceProviderName: {
    type: String,
    required: true
  },
  duration: {
    type: String,
    required: true
  },
  listingType: {
    type: String,
    required: true
  },
  baseRate: {
    type: Number,
    required: true
  },
  currency: {
    type: String,
    required: true
  },
  locale: {
    type: String,
    required: true
  },
  schedules: {
    type: Array,
    default: () => []
  }
});
</script>

<style scoped>
.rate {
  color: #F44336;
  font-weight: bold;
}

.faq-panels {
  border-left: 3px solid #E0E0E0;
  padding-left: 8px;
}

:deep(.v-expansion-panel) {
  border: none !important;
  box-shadow: none !important;
  background-color: rgba(0, 0, 0, 0.01) !important;
  border-radius: 4px !important;
  overflow: hidden;
}

:deep(.v-expansion-panel-title) {
  min-height: 52px;
}

:deep(.v-expansion-panel-text__wrapper) {
  padding: 0 !important;
}

:deep(.v-expansion-panel--active) {
  background-color: rgba(0, 0, 0, 0.02) !important;
}

:deep(p) {
  margin-bottom: 12px;
  line-height: 1.6;
}
</style> 